/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "World",
  size: 20
}

const SvgWorld = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M1 10.5h18M2.35 15.5h15.3M2.35 5.5h15.173M10 19.46h-.02c-2.67-2.13-4.37-5.319-4.37-8.88 0-3.56 1.72-6.75 4.39-8.88.01 0-.01 0 0 0h0c2.67 2.13 4.4 5.32 4.4 8.88 0 3.561-1.73 6.75-4.4 8.88h0z"
    />
    <circle fill="none" cx={10} cy={10.5} r={9} />
  </Svg>
)

SvgWorld.defaultProps = defaultProps
export default SvgWorld
